import LocalstorageService from '../helpers/localstorage-service';
import { AuthUserInfo, CompanyId, JobRole, UserId, USER_ROLE } from '../constants';
import { getIsraelBusinessDate } from '../helpers/dateUtils';
import profitabilityService from './profitability';
import EmployeeService from './employee';
import MachineService from './machines';

// These exact loaders are used by React.lazy and by intent-based prefetch.
export const screenLoaders = {
  '/loading-terminal/list': () => import('../pages/EmployeeActivity/ListEmployeeTerminalsV2'),
  '/loading-terminal/terminal-loads': () => import('../pages/EmployeeActivity/EmployeeLoadsListV2'),
  '/profitability/monthly-report': () => import('../pages/Profitability/MonthlyReportV2'),
  '/profitability/expenses': () => import('../pages/Profitability/MonthlyExpensesV2'),
};
const silent = { prefetch: true, skipErrorToast: true };
// Only reads: never invokes recalculate, charging, rebuilding, or a hidden React screen.
export const preloadScreen = async (route) => {
  if (!screenLoaders[route] || !LocalstorageService.getItem(AuthUserInfo)?.token
      || document.visibilityState === 'hidden') return;
  const companyId = Number(LocalstorageService.getItem(CompanyId));
  if (!companyId) return;
  const work = [screenLoaders[route]()];
  const now = new Date();
  const month = now.getMonth() + 1, year = now.getFullYear();
  if (route.startsWith('/loading-terminal/')) {
    work.push(EmployeeService.listEmployee({ companyId }, silent));
    const employeeScreen = route.endsWith('/terminal-loads');
    const role = Number(LocalstorageService.getItem(JobRole));
    const employeeId = employeeScreen
      ? role === USER_ROLE.COMPANY_ADMIN ? Number(localStorage.getItem('emp_id') || 0) : Number(LocalstorageService.getItem(UserId) || 0)
      : 0;
    work.push(MachineService.terminalList({ companyId, employeeId,
      dateS: getIsraelBusinessDate().toLocaleDateString('en-US'),
      sort: [{ value: employeeScreen ? 'rowOrder' : 'loadingAmount', asc: employeeScreen }],
    }, silent));
  } else if (route.endsWith('/monthly-report')) {
    const previous = new Date(year, month - 2, 1);
    // GetProfitabilityReport may rebuild data. Keep it on explicit navigation,
    // until rebuild and read are separated; only prepare pure summary reads.
    work.push(profitabilityService.getFinancialSummary({ companyId, month: previous.getMonth() + 1, year: previous.getFullYear() }, silent));
    work.push(profitabilityService.getFinancialSummary({ companyId, month, year }, silent));
  } else {
    work.push(profitabilityService.getExpenseSources({ companyId, includeInactive: true }, silent));
    work.push(profitabilityService.getExpenses({ companyId, month, year }, silent));
    work.push(profitabilityService.getExpenseCategoriesV2({ companyId, statusFilter: 'active' }, silent));
    work.push(profitabilityService.getRecognitionPresets(silent));
  }
  await Promise.allSettled(work);
};

// Opt-in Dev experiment. Only the last visited screen, while the app is visible.
// This does not mount React screens or modify their displayed data.
export const startBackgroundScreenReads = (getRoute) => {
  if (process.env.REACT_APP_BACKGROUND_SCREEN_READS !== 'true') return () => {};
  const timer = window.setInterval(() => {
    if (document.visibilityState !== 'hidden') void preloadScreen(getRoute()).catch(() => {});
  }, 5 * 60 * 1000);
  return () => window.clearInterval(timer);
};
